import { CSSProperties } from "@mui/material";
import { LeadListingsLabel, LeadSalesLabel } from "@/modules/lead-page/types";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

export const leadPageMainTabs = [
  {
    id: "activity",
    label: "Activity",
  },
  {
    id: "properties",
    label: "Properties",
  },
  {
    id: "sales",
    label: "Sales",
  },
  { id: "interests", label: "Interests" },
  { id: "developer_tracks", label: "Developer Tracks" },
  { id: "reviews", label: "Reviews" },
];

// Enum for active tab states
export enum LeadPageTab {
  ACTIVITY = "activity",
  PROPERTIES = "properties",
  SALES = "sales",
  INTERESTS = "interests",
  DEVELOPER_TRACKS = "developer_tracks",
  REVIEWS = "reviews",
}

export const getMentionStyle = (): {
  control: CSSProperties;
  highlighter: CSSProperties;
  input: CSSProperties;
  suggestions: {
    list: CSSProperties;
    item: CSSProperties;
  };
} => {
  return {
    control: {
      backgroundColor: "transparent",
      fontSize: 14,
      width: "100%",
      padding: 0,
      height: "100%",
      border: "none",
      borderRadius: "none",
    },
    highlighter: {
      overflow: "hidden",
    },
    input: {
      width: "100%",
      minHeight: 20,
      padding: 0,
      overflowY: "hidden",
      margin: 0,
      fontSize: 14,
      border: "none",
      outline: "none",
      resize: "none",
    },
    suggestions: {
      list: {
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        fontSize: 14,
        marginTop: 4,
        padding: 0,
        maxHeight: 200,
        overflowY: "auto",
        position: "absolute",
        bottom: "100%", // open upward
        zIndex: 1300,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        minWidth: 300,
        maxWidth: 400,
      },
      item: {
        padding: 0,
      },
    },
  };
};

export const leadSalesLabels: LeadSalesLabel[] = [
  { key: "property_type", label: "Property Type", type: "string" },
  { key: "unit_number", label: "Unit Number", type: "string" },
  { key: "unit_value", label: "Unit Value", type: "money" },
  { key: "date_of_reservation", label: "Date of Reservation", type: "date" },
  { key: "date_of_contraction", label: "Date of Contraction", type: "date" },
  { key: "actual_value", label: "Actual Amount", type: "money" },
  { key: "sales_agent", label: "Sales Agent", type: "string" },
  { key: "sale_category", label: "Sale Category", type: "string" },
  { key: "linked_sale_type", label: "Linked Sale Type", type: "string" },
];

export const leadListingsLabels: LeadListingsLabel[] = [
  { key: "unitId", label: "Unit id" },
  { key: "unitNumber", label: "Unit Number" },
  { key: "ownerName", label: "Customer Name" },
  { key: "propertyType", label: "Property Type" },
  { key: "bedrooms", label: "Bedrooms" },
  { key: "unitArea", label: "Unit Area" },
  { key: "actualPrice", label: "Unit Price" },
  { key: "maintenance", label: "Maintenance" },
  { key: "lastInstallmentDate", label: "Last Installment Date" },
  { key: "askingPrice", label: "Unit Asking Price" },
  { key: "readyBy", label: "Delivery Date" },
  { key: "listingAgentEmail", label: "Assigned Admin" },
  { key: "unitAddress", label: "Unit Address" },
  { key: "floorNumber", label: "Floor Number" },
  { key: "bathrooms", label: "Bathrooms" },
  { key: "gardenArea", label: "Garden Area" },
  { key: "remainingInstallments", label: "Remaining Installments" },
  { key: "downpayment", label: "Down Payment" },
  { key: "finishing", label: "Finishing" },
  { key: "status", label: "Status" },
  { key: "phase", label: "Phase" },
  { key: "roofArea", label: "Roof Area" },
  { key: "isUnderConstruction", label: "Under Construction" },
  { key: "updatedAt", label: "Updated At" },
];

export const commentBulbBackgroundMap = new Map([
  ["default", nawyTheme.nawy.colors.semantic.layer.accent],
  ["deleted", nawyTheme.nawy.colors.semantic.indicator.redLight],
  ["child", nawyTheme.nawy.colors.semantic.indicator.yellowLight],
  ["ai_comment", nawyTheme.nawy.colors.semantic.layer.accent],
  ["lead_mining", nawyTheme.nawy.colors.semantic.indicator.green],
]);

// Foreground text colors keyed to the same map as commentBulbBackgroundMap.
// Any bulb whose background is dark/saturated (accent blue, green) must use
// onColor; pale tints (red/yellow light) stay on the default text.primary.
export const commentBulbColorMap = new Map([
  ["default", nawyTheme.nawy.colors.semantic.text.onColor],
  ["ai_comment", nawyTheme.nawy.colors.semantic.text.onColor],
  ["lead_mining", nawyTheme.nawy.colors.semantic.text.onColor],
]);
